import { ReactNode, useState } from 'react';

interface Props {
  pass: string;
  children: ReactNode;
}

export default function Password({ pass, children }: Props) {
  const [input, setInput] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleSubmit = () => {
    if (input === pass) {
      setIsValid(true);
      setIsError(false);
    } else {
      setIsError(true);
    }
  };

  if (isValid) return <>{children}</>;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100dvh',
        zIndex: 99,
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '55px',
      }}
    >
      <h1 className="has-heading-1-font-size">Password Required</h1>
      <h5
        className="has-heading-5-font-size text-center"
        style={{ width: '50%', whiteSpace: 'pre-line' }}
      >
        {`Please enter your password to view this project, \nor contact me to request access.`}
      </h5>

    
      <input
        style={{ width: '50%', borderColor: isError ? 'red' : undefined }}
        className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
        onChange={(e) => { setInput(e.target.value); setIsError(false); }}
        value={input}
        type="password"
        placeholder="Password"
      />
      <button onClick={handleSubmit} className="btn">
        Enter Password
      </button>
    </div>
  );
}
